module.exports = __webpack_public_path__ + "img/ic24Share.9ba8effe.svg";